import { i18n } from "../../../translate/i18n";

export default {
  formId: 'checkoutForm',
  formField: {
    firstName: {
      name: 'firstName',
      label: i18n.t("checkoutPage.form.fullName"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.fullNameRequired")
    },
    lastName: {
      name: 'lastName',
      label: i18n.t("checkoutPage.form.lastName"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.lastNameRequired")
    },
    address1: {
      name: 'address2',
      label: i18n.t("checkoutPage.form.address"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.addressRequired")
    },

    city: {
      name: 'city',
      label: i18n.t("checkoutPage.form.city"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.cityRequired")
    },
    state: {
      name: 'state',
      label: i18n.t("checkoutPage.form.state"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.stateRequired")
    },
    zipcode: {
      name: 'zipcode',
      label: i18n.t("checkoutPage.form.document"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.zipcodeRequired"),
      invalidErrorMsg: i18n.t("checkoutPage.validation.zipcodeInvalid")
    },
    country: {
      name: 'country',
      label: i18n.t("checkoutPage.form.country"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.countryRequired")
    },
    useAddressForPaymentDetails: {
      name: 'useAddressForPaymentDetails',
      label: i18n.t("checkoutPage.form.useAddressForPayment")
    },
    nameOnCard: {
      name: 'nameOnCard',
      label: i18n.t("checkoutPage.form.nameOnCard"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.nameOnCardRequired")
    },
    cardNumber: {
      name: 'cardNumber',
      label: i18n.t("checkoutPage.form.cardNumber"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.cardNumberRequired"),
      invalidErrorMsg: i18n.t("checkoutPage.validation.cardNumberInvalid")
    },
    expiryDate: {
      name: 'expiryDate',
      label: i18n.t("checkoutPage.form.expiryDate"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.expiryDateRequired"),
      invalidErrorMsg: i18n.t("checkoutPage.validation.expiryDateInvalid")
    },
    cvv: {
      name: 'cvv',
      label: i18n.t("checkoutPage.form.cvv"),
      requiredErrorMsg: i18n.t("checkoutPage.validation.cvvRequired"),
      invalidErrorMsg: i18n.t("checkoutPage.validation.cvvInvalid")
    }
  }
};
